var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.42 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #6533e9;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.21,
    cy: 29.21,
    r: 8.94,
    transform: "translate(-4.3 53.36) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.26,53.68v5.07H11.16v-5.07c0-4,1.52-7.63,3.98-10.38,2.85-3.15,6.98-5.14,11.56-5.14h5.01c4.58,0,8.71,1.99,11.56,5.14,2.46,2.75,3.98,6.39,3.98,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.26,58.75v-5.07c0-4-1.52-7.63-3.98-10.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.09,33.79c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58,4.58,2.05,4.58,4.58-2.05,4.58-4.58,4.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.21,
    y1: 29.21,
    x2: 48.5,
    y2: 29.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.33,24.63c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58S.75,31.74.75,29.21s2.05-4.58,4.58-4.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.2,
    y1: 29.21,
    x2: 9.91,
    y2: 29.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.09,33.79c-2.53,0-4.58-2.05-4.58-4.58s2.05-4.58,4.58-4.58,4.58,2.05,4.58,4.58-2.05,4.58-4.58,4.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.21,
    y1: 29.21,
    x2: 48.5,
    y2: 29.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.33,24.63c2.53,0,4.58,2.05,4.58,4.58s-2.05,4.58-4.58,4.58S.75,31.74.75,29.21s2.05-4.58,4.58-4.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.2,
    y1: 29.21,
    x2: 9.91,
    y2: 29.21
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.79,5.33c0,2.53-2.05,4.58-4.58,4.58s-4.58-2.05-4.58-4.58S26.68.75,29.21.75s4.58,2.05,4.58,4.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.21,
    y1: 15.2,
    x2: 29.21,
    y2: 9.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.33,15.56c-1.79,1.79-4.69,1.79-6.48,0-1.79-1.79-1.79-4.69,0-6.48,1.79-1.79,4.69-1.79,6.48,0,1.79,1.79,1.79,4.69,0,6.48Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.11,
    y1: 19.31,
    x2: 42.85,
    y2: 15.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.56,9.09c1.79,1.79,1.79,4.69,0,6.48-1.79,1.79-4.69,1.79-6.48,0-1.79-1.79-1.79-4.69,0-6.48s4.69-1.79,6.48,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.31,
    y1: 19.31,
    x2: 15.56,
    y2: 15.56
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.58,58.75v-3.34h.04s2.84-.4,2.84-.4c.21-.83.54-1.62.96-2.34l-1.75-2.31,2.63-2.63,2.31,1.75c.73-.42,1.51-.76,2.34-.97l.4-2.87h3.72l.4,2.87c.83.21,1.61.55,2.34.97l2.31-1.75,2.62,2.63-1.74,2.31c.42.72.75,1.51.96,2.34l2.88.4v3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,58.75c.18-.46.28-.96.28-1.48,0-2.25-1.82-4.07-4.07-4.07s-4.07,1.82-4.07,4.07c0,.52.1,1.02.28,1.48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFive);
export default __webpack_public_path__ + "static/media/big-five.772982bcde43957b3b95e87b3295f54d.svg";
export { ForwardRef as ReactComponent };